<template>
  <div>
    <h4>酒店管理</h4>
    <router-view></router-view>
  </div>
</template>
